import React from 'react';
import darkBackground from '../assets/tinkerlabs__web__dark_hatter.webp';
import astronautLeft from '../assets/tinkerlabs__web__fig1.webp';
import astronautRight from '../assets/tinkerlabs__web__fig2.webp';
import photo1 from '../assets/Fotografija_2-min.jpg';

const NeedForSteam = ({toSection,section}) => {
  const scrollToForm = () => {
    const formElement = document.getElementById('contact-form');
    if (formElement) {
      formElement.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <div className="relative" id="needforsteem">
      {/* Top wave */}
      <div style={{zIndex:9}} className="absolute top-0 left-0 right-0">
        <svg 
          viewBox="0 0 1440 200" 
          className="w-full"
          preserveAspectRatio="none"
          style={{ height: '200px', transform: 'rotate(180deg)' }}
        >
          <path 
            fill="white" 
            d="M0,64L48,80C96,96,192,128,288,128C384,128,480,96,576,85.3C672,75,768,85,864,96C960,107,1056,117,1152,112C1248,107,1344,85,1392,74.7L1440,64L1440,200L1392,200C1344,200,1248,200,1152,200C1056,200,960,200,864,200C768,200,672,200,576,200C480,200,384,200,288,200C192,200,96,200,48,200L0,200Z"
          />
        </svg>
      </div>

      {/* Main content */}
      <div className="bg-[#fff] min-h-[80vh] relative mt-0">
        {/* Background with stars */}
        <div className="absolute inset-0">
          <img 
            src={darkBackground}
            alt="Starry background" 
            className="w-full h-full object-cover"
          />
        </div>

        {/* Floating astronauts */}
        <div className="absolute left-0 top-1/2 -translate-y-1/2 z-10">
          <img 
            src={astronautLeft}
            alt="Left floating astronaut" 
            className="w-40 h-auto animate-float"
          />
        </div>
        <div className="absolute right-0 top-1/2 -translate-y-1/2 z-10">
          <img 
            src={astronautRight}
            alt="Right floating astronaut" 
            className="w-40 h-auto animate-float-delayed"
          />
        </div>

        {/* Content container - White box with shadow */}
        <div  className="relative z-10 container mx-auto px-2 py-40">
        <div className="container mx-auto px-4">
        <div  className="grid md:grid-cols-2 gap-12 ">
         
               {/* Text content */}
              <div className='bg-white rounded-2xl shadow-xl p-10'>
              <h2 className="font-['Grandstander'] text-[#002147] text-2xl font-extrabold mb-6 text-center">
                  The World needs  STEAM-fueled leaders
                </h2>
                <h3 className="font-['Lexend'] text-2xl mb-6 text-[#1678F2]">
                  Tinker Labs is Here to Help!
                </h3>
                <p className="font-['Lexend'] text-[#002147] text-sm mb-1 ">
                  The need for STEAM education in today's world is skyrocketing. Parents are eager to equip 
                  their children with the tools they need for a technology-driven future, but also provide 
                  them with critical thinking skills needed for success.
                </p>
                <p className="text-[#002147] font-['Lexend']  text-sm mb-1 leading-relaxed">
                  Tinker Labs presents a unique franchise opportunity that not only empowers the next 
                  generation with essential skills but also allows you to build a successful business.
                </p>
                <p className="text-[#002147] font-['Lexend']  text-sm mb-1 leading-relaxed">
                With over 120 locations across Europe, Tinker Labs is not just a franchise,  it’s a movement dedicated to nurturing curiosity, creativity, and critical thinking in children. Join us in delivering high-quality STEAM education to communities across the world, empowering children to think boldly and solve creatively.
                </p>
                <button onClick={()=>{toSection('section3')}} className="bg-[#FF6B2C] text-white px-8 py-3 rounded-[50px] font-['Lexend'] font-semibold hover:bg-[#FF5A1F] transition-all">
                  Learn more
                </button>
              </div>

              {/* Image side */}
              <div className="bg-white rounded-2xl shadow-xl ">
                <img 
                  src={photo1} 
                  alt="Children learning" 
                  className="w-auto h-full rounded-lg shadow-lg"
                  style={{ objectFit: 'cover' }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg 
            viewBox="0 0 1440 200" 
            className="w-full"
            preserveAspectRatio="none"
            style={{ height: '100px' }}
          >
          </svg>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
        @keyframes floatDelayed {
          0%, 100% { transform: translateY(-20px); }
          50% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 6s ease-in-out infinite;
        }
        .animate-float-delayed {
          animation: floatDelayed 6s ease-in-out infinite;
        }
      `}</style>
    </div>
  );
};

export default NeedForSteam;